export const NO_DATA = "No data"
export const ID_FATHER_NODE = "total"
export const SHORTENING = "..."
export const LIMIT_LENGTH_TITLE_FATHER_NODE = 28
export const POSITION_TO_START_GET_FATHER_NODE = 0
export const ZERO = 0
export const INDEX_ZERO = 0
export const INDEX_ONE = 1
export const INDEX_TWO = 2
